function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../style/pages/agency-listing.css";
import * as Listing from "./components/listing";
import { LISTING_MODE } from "./components/listing";
import "core-js/modules/es.array.iterator";
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import BaseDropDown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import { useShowPhone } from "@wkComposables/useShowPhone";
//@ts-ignore
import { useContactAgencyModal } from "@wkComposables/useContactAgencyModal";
import CommonModals from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import { useShareModal } from "@wkComposables/useShareModal";
//@ts-ignore
import BaseComplexToggle from "@vueEntry/UIKitComponents/BaseComplexToggle.vue";
//@ts-ignore
import { COLORS, MAP_TILER_APIKEY } from "@wkWebSrc/js/components/variables";
//@ts-ignore
import { useSearch } from "@wkComposables/useSearch";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import { Modals } from "@customTypes/Modals";
//@ts-ignore
import PlaceBox from "@vueEntry/PlaceBox.vue";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseIcon from "@vueEntry/UIKitComponents/BaseIcon.vue";
//@ts-ignore
import { calcPolygonCenter, parsePoints } from "@utils/MapUtils";
//@ts-ignore
import { PLACE_TYPE } from "@customTypes/PlaceType";
//@ts-ignore
import { getAgenciesData, getMapMarkers } from "@services/agencyAPI";
//@ts-ignore
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
//@ts-ignore
import { emptyElem, getSingleElement, hideElem, showElem } from "@utils/DOMUtils";
import { createApp, defineAsyncComponent } from "vue";
//@ts-ignore
import { useAgencyFilters } from "@wkComposables/useAgencyFilters";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
import { mapActions, mapState, createPinia } from "pinia";
import { useBaseStore, useSearchBeanStore, useAgencySearchBeanStore, useModalStore, usePublicUserMenuStore, useLoggedUserStore, useMetadataStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import { PrestigeIcon } from "@vueEntry/SvgIcons/PrestigeIcon";
//@ts-ignore
import { handleInsertionClick } from "@wkWebSrc/js/components/insertion";
//@ts-ignore
import { handleBreadcrumbLinkClick } from "@wkWebSrc/js/components/navigationBreadcrumb";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
var insertionHandlerClick = null;
var insertionMediaWrapperClick = null;
var agencyListingApp = createApp({
  name: "WikiAgency",
  components: Object.assign(Object.assign(Object.assign({
    PublicUserMenu: PublicUserMenu,
    PlaceBox: PlaceBox,
    BaseButton: BaseButton,
    BaseIcon: BaseIcon,
    BaseComplexToggle: BaseComplexToggle,
    BaseBtModal: BaseBtModal,
    BaseBadge: BaseBadge,
    BaseDropDown: BaseDropDown,
    //@ts-ignore
    "map-modal": defineAsyncComponent(function () {
      return import("@vmodals/MapModal.vue");
    }),
    //@ts-ignore
    "place-modal": defineAsyncComponent(function () {
      return import("@vmodals/PlaceModal.vue");
    }),
    //@ts-ignore
    "contact-agency-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/ContactAgencyModal.vue");
    }),
    //@ts-ignore
    "filters-agency-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/FiltersAgencyModal.vue");
    }),
    //@ts-ignore
    "request-prestigious-modal": defineAsyncComponent(function () {
      return import("./vue/Modals/RequestPrestigiousModal.vue");
    }),
    PrestigeIcon: PrestigeIcon
  }, CommonModals), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(function () {
      return import("@vueEntry/UIKitComponents/BaseDropDown.vue");
    })
  }), LanguageIcons),
  setup: function setup() {
    var _useShowPhone = useShowPhone(),
      displayPhone = _useShowPhone.displayPhone,
      phoneLabel = _useShowPhone.phoneLabel,
      showPhone = _useShowPhone.showPhone;
    var _useFirebaseMessaging = useFirebaseMessaging(),
      showFirebaseSnackbar = _useFirebaseMessaging.showFirebaseSnackbar,
      snackbarTitle = _useFirebaseMessaging.snackbarTitle,
      snackbarBody = _useFirebaseMessaging.snackbarBody,
      snackbarIcon = _useFirebaseMessaging.snackbarIcon,
      handleOnForegroundNotificationClick = _useFirebaseMessaging.handleOnForegroundNotificationClick;
    var _useContactAgencyModa = useContactAgencyModal(),
      agencyModalData = _useContactAgencyModa.agencyModalData,
      reopenAfterLogin = _useContactAgencyModa.reopenAfterLogin,
      successModalDataEmitted = _useContactAgencyModa.successModalDataEmitted,
      amdLabels = _useContactAgencyModa.amdLabels,
      amdIcons = _useContactAgencyModa.amdIcons,
      listingType = _useContactAgencyModa.listingType,
      openContactModal = _useContactAgencyModa.openContactModal,
      openAndReturnToCAMS = _useContactAgencyModa.openAndReturnToCAMS;
    var _useAppBanner = useAppBanner(),
      isAppBannerVisible = _useAppBanner.isAppBannerVisible;
    var _useShareModal = useShareModal(),
      shareModalData = _useShareModal.shareModalData,
      openShareModal = _useShareModal.openShareModal,
      gaEvent = _useShareModal.gaEvent;
    var _useSearch = useSearch(),
      search = _useSearch.search;
    var _useAgencyFilters = useAgencyFilters(),
      agencyFilter = _useAgencyFilters.agencyFilter,
      currentSearchName = _useAgencyFilters.currentSearchName,
      labels = _useAgencyFilters.labels;
    var _useUtilities = useUtilities(),
      redirectTo = _useUtilities.redirectTo;
    var _useBreakpoints = useBreakpoints(),
      isLarge = _useBreakpoints.isLarge;
    useTrustpilotWidget();
    return {
      isLarge: isLarge,
      displayPhone: displayPhone,
      phoneLabel: phoneLabel,
      showPhone: showPhone,
      isAppBannerVisible: isAppBannerVisible,
      //Contact Agency Modal (CAM)
      //CAM state
      agencyModalData: agencyModalData,
      reopenAfterLogin: reopenAfterLogin,
      successModalDataEmitted: successModalDataEmitted,
      //CAM computed
      amdLabels: amdLabels,
      amdIcons: amdIcons,
      listingType: listingType,
      //CAM methods
      openContactModal: openContactModal,
      openAndReturnToCAMS: openAndReturnToCAMS,
      //useFirebaseMessaging
      showFirebaseSnackbar: showFirebaseSnackbar,
      snackbarTitle: snackbarTitle,
      snackbarBody: snackbarBody,
      snackbarIcon: snackbarIcon,
      handleOnForegroundNotificationClick: handleOnForegroundNotificationClick,
      //useSearch
      search: search,
      //useShareModal
      shareModalData: shareModalData,
      openShareModal: openShareModal,
      gaEvent: gaEvent,
      //useCommonVars
      agencyFilter: agencyFilter,
      currentSearchName: currentSearchName,
      labels: labels,
      redirectTo: redirectTo
    };
  },
  data: function data() {
    return {
      ListingInit: {
        list: "#agencies-with-re-list",
        "buildInfoWindow": buildInfoWindow,
        click: true
      },
      activeMode: "Lista",
      mapInitialized: false,
      customListingTypologyURL: "",
      useContractType: false,
      place: JSON.parse(window["_serializedPlace"]),
      collapsed: true,
      map: null,
      isPrestige: null,
      currentPage: window["_currentPage"]
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    mapRangeForMarkers: function mapRangeForMarkers() {
      return window._freesearch || this.searchBean.placeType == PLACE_TYPE.REGION ? 1000000 : window._mapRange;
    },
    currentSearchFranchiseId: function currentSearchFranchiseId() {
      return Number.parseInt(new URLSearchParams(window.location.search).get("Franchise") || "");
    },
    checkedMap: function checkedMap() {
      return window.location.hash === "#map";
    },
    checkedList: function checkedList() {
      return !this.checkedMap || window.location.hash === "#list";
    },
    listMode: function listMode() {
      return this.activeMode === "Lista";
    },
    mapMode: function mapMode() {
      return !this.listMode;
    },
    orderOptions: function orderOptions() {
      return window.orderOptions;
    },
    orderSelected: function orderSelected() {
      var _this = this;
      return this.orderOptions.find(function (option) {
        return option.id === _this.searchBean.filterOrderId;
      }) || {
        id: 0
      };
    },
    polygonPoints: function polygonPoints() {
      return this.searchBean.polygonFromMap ? parsePoints(this.searchBean.polygonFromMap) : [];
    },
    currentMapCenter: function currentMapCenter() {
      var _a, _b;
      return this.searchBean.polygonFromMap ? calcPolygonCenter(this.polygonPoints) : {
        lat: ((_a = this.place) === null || _a === void 0 ? void 0 : _a.latitude) || 42.4153262,
        lng: ((_b = this.place) === null || _b === void 0 ? void 0 : _b.longitude) || 12.6428742
      };
    },
    agencySearchBean: function agencySearchBean() {
      return JSON.parse(window["_serializedAgencySearchBean"]);
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])), mapState(useSearchBeanStore, ["searchBean"])), mapState(useAgencySearchBeanStore, ["searchBeanAgency"])), mapState(useMetadataStore, ["pageName"])),
  watch: {
    activeMode: {
      handler: function handler(cur) {
        if (cur === LISTING_MODE.MAP) {
          sendGAEvent("agency_listing_view", {
            view_type: "map",
            event_location: this.pageName
          });
          this.$refs.footer.classList.add("tw-hidden");
          this.$refs.footer.classList.remove("tw-block");
          window.history.pushState(Date.now(), "", "#map");
          if (!this.mapInitialized) {
            this.initMap();
            this.mapInitialized = true;
          } else window.dispatchEvent(new Event("resize"));
        } else {
          sendGAEvent("agency_listing_view", {
            view_type: "default",
            event_location: this.pageName
          });
          window.history.pushState(Date.now(), "", "#list");
          this.$refs.footer.classList.add("tw-block");
          this.$refs.footer.classList.remove("tw-hidden");
        }
      },
      deep: true
    }
  },
  created: function created() {
    this.checkedList && sendGAEvent("agency_listing_view", {
      view_type: "default",
      event_location: this.pageName
    });
    var _url = new URL(window.location.href);
    var queryParams = new URLSearchParams(_url.search);
    if (queryParams.get("Pregio") === "true") {
      this.isPrestige = true;
    } else if (queryParams.get("Pregio") === "false") this.isPrestige = false;
    this.initPublicUserMenu();
    this.updateAgencySearchBean(Object.assign(Object.assign({}, this.agencySearchBean), {
      isPrestigious: this.isPrestige
    }));
    //this because the search() is based on the searchBean and needed some changes to make it works with the agencySearchBean
    this.updateSearchBean(this.agencySearchBean);
    this.customListingTypologyURL = this.labels.macroTypology_url_5;
    if (this.currentSearchName || this.currentSearchFranchiseId) {
      this.agencyFilter = {
        name: this.currentSearchName,
        franchiseId: this.currentSearchFranchiseId
      };
    }
    //default set to disclaimer
    this.openModal("AG_DISCLAIMER_MODAL");
  },
  mounted: function mounted() {
    hideNavigationBreadcrumb();
    Listing.init({
      list: "#list-agencies",
      buildInfoWindow: buildInfoWindow
    });
  },
  methods: Object.assign(Object.assign(Object.assign(Object.assign({
    handleBreadcrumbLinkClick: handleBreadcrumbLinkClick,
    handleInsertionClick: handleInsertionClick,
    searchAgencies: function searchAgencies(agencyFilters) {
      var fromPrestigeButton = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.search(true, this.labels.macroTypology_url_5, false, agencyFilters);
    },
    isPrestigeClick: function isPrestigeClick() {
      var UrlCharacter = "";
      if (this.agencyFilter.name === "") UrlCharacter = "?";else UrlCharacter = "&";
      var urlString = window.location.href;
      var _url = new URL(window.location.href);
      var _queryString = new URLSearchParams(_url.search);
      urlString = "".concat(_url.origin).concat(_url.pathname);
      if (_queryString.get("Nome")) urlString += "?Nome=".concat(_queryString.get("Nome"));
      urlString += UrlCharacter;
      if (!this.isPrestige) {
        urlString += "Pregio=true";
        this.isPrestige = true;
      } else {
        urlString += this.currentPage > 1 ? "p=".concat(this.currentPage, "&Pregio=false") : "Pregio=false";
        this.isPrestige = false;
      }
      this.updateAgencySearchBean({
        isPrestigious: this.isPrestige
      });
      window.location.href = urlString;
    },
    saveFilterAgency: function saveFilterAgency(agencyFilter) {
      this.agencyFilter = Object.assign({}, agencyFilter);
    },
    openModal: function openModal(modalName) {
      this.setShowModal(modalName);
    },
    closeModal: function closeModal(modalName) {
      this.setShowModal(Modals.noModal);
    },
    setActiveMode: function setActiveMode(newMode) {
      this.activeMode = newMode;
    },
    initMap: function initMap() {
      var _a;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var _yield$Promise$all, _yield$Promise$all2, leafletModule, leafletCSSModule, mapCSSModule, swiperModule, LeafletMap, map_selector;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([
              //@ts-ignore
              import( /* webpackChunkName: "chunks/leaflet_map" */"@wkWebSrc/js/LeafletMap/leaflet_map"), require( /* webpackChunkName: "chunks/leaflet_theme" */"../style/vendor/leafleft.theme.css"), require( /* webpackChunkName: "chunks/map" */"../style/layout/map.css"), import("swiper"),
              //@ts-ignore
              import("swiper/css")]);
            case 2:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
              leafletModule = _yield$Promise$all2[0];
              leafletCSSModule = _yield$Promise$all2[1];
              mapCSSModule = _yield$Promise$all2[2];
              swiperModule = _yield$Promise$all2[3];
              LeafletMap = leafletModule["default"];
              this.map = new LeafletMap();
              map_selector = this.$refs.listingMapPlaceholder;
              (_a = this.map) === null || _a === void 0 ? void 0 : _a.init(map_selector, MAP_TILER_APIKEY, COLORS);
              this.map.ready(function () {
                var _a;
                var mapCarouselHTMLString = "\n                    <div id=\"infowindow-carousel-dynamic\" \n                         class=\"swiper infowindow-carousel infowindow-carousel-container tw-rounded tw-bg-white tw-text-left tw-m-0 sm:tw-hidden\"\n                         style=\"display: none\"\n                         >\n                         <div class=\"swiper-wrapper\"></div>\n                    </div>";
                var mapCarouselEl = null;
                var infowindowCarousel = null;
                (_a = _this2.map) === null || _a === void 0 ? void 0 : _a.getMapContainer().insertAdjacentHTML("afterend", mapCarouselHTMLString);
                _this2.map.startSpinner();
                _this2.ListingInit.getMapMarkers = function () {
                  getMapMarkers(_this2.searchBeanAgency).then(function (markers) {
                    var _a, _b;
                    if (_this2.polygonPoints.length) {
                      (_a = _this2.map) === null || _a === void 0 ? void 0 : _a.deleteShape();
                      (_b = _this2.map) === null || _b === void 0 ? void 0 : _b.drawPolygonFromPoints(_this2.polygonPoints);
                    }
                    _this2.map.initMarkerClusterer();
                    _this2.map.addMarkerBulk(markers, _this2.currentMapCenter, _this2.mapRangeForMarkers);
                    if (_this2.map.hasShape()) _this2.map.fitBounds(_this2.map.getShape().getBounds());else if (_this2.map.getMarkersCount()) _this2.map.fitBounds(_this2.map.getMarkerClusterer().getBounds());
                    _this2.map.getMap().invalidateSize();
                    _this2.map.addListener(_this2.map.getMarkerClusterer(), "click", function (e) {
                      var marker = e.layer;
                      _this2.map.highlightCluster(marker);
                      buildInfoWindow([marker["id"]]).then(function (html) {
                        return drawInfowindows(html, marker.getLatLng());
                      });
                    });
                    var drawInfowindows = function drawInfowindows(html, position) {
                      _this2.map.getInfowindow().setLatLng(position);
                      _this2.map.getMap().openPopup(_this2.map.getInfowindow());
                      emptyElem("#wrapper-single");
                      var infoWindowMultipleEl = getSingleElement("#wrapper-multiple");
                      infoWindowMultipleEl.innerHTML = html;
                      // @ts-ignore
                      showElem(infoWindowMultipleEl);
                      // $mapCarousel.show();
                      mapCarouselEl = getSingleElement("#infowindow-carousel-dynamic");
                      //Inserting the items content into the carousel
                      var swiperWrapperEl = mapCarouselEl.getElementsByClassName("swiper-wrapper")[0];
                      //Emptying the carousel items so we know that there will be no duplicates
                      emptyElem(swiperWrapperEl);
                      //Inserting the elements in an empty carousel
                      swiperWrapperEl.insertAdjacentHTML("afterbegin", html);
                      var Swiper = swiperModule["default"];
                      infowindowCarousel === null || infowindowCarousel === void 0 ? void 0 : infowindowCarousel.destroy();
                      infowindowCarousel = new Swiper("#infowindow-carousel-dynamic", {
                        spaceBetween: 100
                      });
                      showElem(mapCarouselEl);
                      _this2.map.getInfowindow()._adjustPan();
                      document.dispatchEvent(new Event("info-event-created"));
                    };
                    _this2.map.addListener(_this2.map.getMap(), "zoomend", function () {
                      var options = _this2.map.getMarkerClusterer().options;
                      if (options) {
                        options.zoomToBoundsOnClick = _this2.map.getZoom() < 16;
                        _this2.map.getMap().closePopup();
                      }
                    });
                    _this2.map.addListener(_this2.map.getMarkerClusterer(), "click", function (e) {
                      var marker = e.layer;
                      _this2.map.highlightCluster(marker);
                      buildInfoWindow([marker["id"]]).then(function (html) {
                        return drawInfowindows(html, marker.getLatLng());
                      });
                    });
                    _this2.map.addListener(_this2.map.getMarkerClusterer(), "clusterclick", function (e) {
                      var cluster = e.layer;
                      var markers = cluster.getAllChildMarkers();
                      var len = markers.length;
                      _this2.map.highlightCluster(cluster);
                      if (len === 1 || _this2.map.getZoom() >= 16) {
                        var ids = [];
                        for (var i = 0; i < len; i++) {
                          ids.push(markers[i].id);
                        }
                        buildInfoWindow(ids).then(function (html) {
                          return drawInfowindows(html, cluster.getLatLng());
                        });
                      }
                    });
                    _this2.map.on("click zoomstart", function () {
                      _this2.map.clearHighlight();
                      // $mapCarousel.hide();
                      hideElem(mapCarouselEl);
                    });
                    _this2.map.getMap().on("popupclose", function () {
                      removeMapInsertionClickListener();
                    });
                  })["finally"](function () {
                    _this2.map.stopSpinner();
                  });
                };
                _this2.ListingInit.getMapMarkers();
              });
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    },
    collapse: function collapse() {
      this.collapsed = !this.collapsed;
    }
  }, mapActions(useBaseStore, ["logout", "initPublicUserMenu"])), mapActions(useSearchBeanStore, ["updateSearchBean"])), mapActions(useAgencySearchBeanStore, ["updateAgencySearchBean"])), mapActions(useModalStore, ["setShowModal"]))
});
agencyListingApp.use(createPinia());
agencyListingApp.mount("#agency-main");
var handleMapInsertionClick = function handleMapInsertionClick() {
  var mediaWrapperList = document.querySelectorAll(".swiper-slide.insertion .media-wrapper");
  var _iterator = _createForOfIteratorHelper(mediaWrapperList),
    _step;
  try {
    var _loop = function _loop() {
      var mediaWrapperEl = _step.value;
      insertionMediaWrapperClick = function insertionMediaWrapperClick(e) {
        return e.preventDefault();
      };
      //Avoid catching from children elements
      mediaWrapperEl.addEventListener("click", insertionMediaWrapperClick);
      var insertionMapEl = mediaWrapperEl.parentElement;
      if (!insertionMapEl) return 1; // continue
      var url = insertionMapEl.dataset.url;
      insertionHandlerClick = function insertionHandlerClick() {
        handleInsertionClick({
          url: url || "",
          blankPage: {
            lg: true
          }
        });
      };
      //Adding insertion on click handler
      insertionMapEl.addEventListener("click", insertionHandlerClick);
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var removeMapInsertionClickListener = function removeMapInsertionClickListener() {
  var _a;
  var mediaWrapperList = document.querySelectorAll(".swiper-slide.insertion .media-wrapper");
  var _iterator2 = _createForOfIteratorHelper(mediaWrapperList),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var mediaWrapperEl = _step2.value;
      insertionMediaWrapperClick && mediaWrapperEl.removeEventListener("click", insertionMediaWrapperClick);
      insertionHandlerClick && ((_a = mediaWrapperEl.parentElement) === null || _a === void 0 ? void 0 : _a.removeEventListener("click", insertionHandlerClick));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  insertionHandlerClick = null;
  insertionMediaWrapperClick = null;
};
document.addEventListener("info-event-created", handleMapInsertionClick);
function hideNavigationBreadcrumb() {
  document.addEventListener("scroll", function () {
    [document.getElementById("navigation-dropdown-breadcrump"), document.getElementById("navigation-dropdown-breadcrump-franchise")].forEach(function (el) {
      return el === null || el === void 0 ? void 0 : el.classList.remove("show");
    });
  });
}
function buildInfoWindow(ids) {
  return new Promise(function (resolve) {
    getAgenciesData(ids).then(function (data) {
      if (!data) return;
      var html = buildListHtml(data);
      resolve(html);
    });
  });
}
function buildListHtml(agencies) {
  var html = "";
  for (var i = 0; i < agencies.length; i++) {
    var agency = agencies[i];
    var mb = "sm:tw-mb-10px";
    if (i === agencies.length - 1) mb = "";
    html += "<li class=\"swiper-slide ".concat(mb, " insertion\" \n                   data-id=\"").concat(agency.id, "\" \n                   data-url=\"").concat(agency.url, "\" \n                   data-target=\"_blank\">\n                   <div class=\"media-wrapper\">\n                     <div class=\"media-left\">\n                        <div class=\"media-thumbnail\">");
    var img = "/rest/agency/getAgencyImageByAgencyID/".concat(agency.id, "/2");
    html += "<img src=\"".concat(img, "\" alt=\"").concat(agency.name, " logo\" width=\"128\" height=\"96\">");
    html += "</div></div>\n                 <div class=\"media-body\">";
    html += "<h4 class=\"tw-text tw-leading-[18px] tw-font-semibold tw-mb-5px\">".concat(agency.name, "</h4>");
    html += "<p class=\"tw-mb-0\">".concat(agency.fullAddress, "</p>");
    html += "</div></div></li>";
  }
  return html;
}